import { IDownloadSummaryAction } from '../actions/download-summary-int/download-summary';
import { ITicketsState } from '../state';

export type IDownloadSummaryFileAction = IDownloadSummaryAction;

export const loadDownloadSummaryReducer = (state: ITicketsState, action: IDownloadSummaryFileAction) => {
    return ({
        ...state,
        downloadStatus: {
            status: action.status
        }
    })
}
